import { SVG_ID } from '%paysera_seat_selection/js/seatSelection/config/constants';

export default (state, { payload }) => {
    const { viewBox: { coordinates, width, height } } = state;
    const difference = payload - width;
    if (width + difference <= 0 || height + difference <= 0) {
        return state;
    }

    let { mouseMove } = state;
    if (mouseMove === null) {
        const svg = document.getElementById(SVG_ID);
        const {
            height: { baseVal: { value: svgHeight } },
            width: { baseVal: { value: svgWidth } },
        } = svg;
        mouseMove = {
            x: coordinates.x + width * 0.5,
            y: coordinates.y + height * 0.5 * svgHeight / svgWidth,
        };
    }

    return {
        ...state,
        viewBox: {
            ...state.viewBox,
            coordinates: {
                x: coordinates.x - difference * (mouseMove.x - coordinates.x) / width,
                y: coordinates.y - difference * (mouseMove.y - coordinates.y) / height,
            },
            width: width + difference,
            height: height + difference,
        },
    };
};
